import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { onMounted, onUnmounted, ref } from 'vue';

export const useBenefitsDesktop = () => {
  const wrapperRef = ref<HTMLElement | null>(null);

  const titleRef = ref<HTMLElement | null>(null);

  gsap.registerPlugin(ScrollTrigger);
  const matchMediaRef = ref<ReturnType<typeof gsap.matchMedia>>();

  const initAnimation = () => {
    if (!wrapperRef.value || !titleRef.value) return;

    const cards = gsap.utils.toArray('.benefit-card');
    if (!cards || !cards.length) return;

    const matchMedia = gsap.matchMedia();
    const finalPositions = [
      { x: -150, y: -250 },
      { x: 300, y: -200 },
      { x: 400, y: 50 },
      { x: 300, y: 275 },
      { x: -300, y: 250 },
      { x: -400, y: 0 }
    ];

    matchMediaRef.value = matchMedia.add('(min-width: 1024px)', () => {
      gsap.set(titleRef.value, {
        opacity: 0,
        scale: 0.5
      });

      gsap.set(cards, {
        opacity: 0,
        position: 'absolute'
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.benefits-section',
            start: 'top center',
            end: '+=200%',
            scrub: 1,
            invalidateOnRefresh: true
          }
        })
        .to(
          cards,
          {
            duration: 0.2,
            opacity: 1,
            ease: 'power2.out',
            stagger: 0
          },
          0
        )
        .to(
          cards,
          {
            duration: 2,
            ease: 'power2.out',
            x: (i) => finalPositions[i].x,
            y: (i) => finalPositions[i].y,
            stagger: 0
          },
          0
        );

      gsap
        .timeline({
          scrollTrigger: {
            trigger: '.benefits-section',
            start: 'center center',
            end: '+=100%',
            scrub: 1,
            pin: true,
            markers: false,
            invalidateOnRefresh: true
          }
        })
        .to(titleRef.value, {
          opacity: 1,
          scale: 1,
          duration: 1.5,
          ease: 'power2.out'
        });
    });
  };

  onMounted(() => {
    initAnimation();
  });

  onUnmounted(() => {
    matchMediaRef.value?.revert();
    matchMediaRef.value = undefined;
  });

  return {
    wrapperRef,
    titleRef
  };
};
